module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_lg_01.316ac025.jpg";